import errorSent from "~/utils/errors/errorSent";
import { setDescription, setTitle } from "~/redux/action-creaters/meta";
import { Api } from "../../api";

export const fetchSection = (
  Redis = false,
  host = "",
  resolvedUrl = "",
  isReset = false,
  // Сортировка главного раздела по продажам. По умолчанию включена — в том
  // числе для клиентских дозагрузок («Показать еще»), которые вызывают
  // fetchSection() без аргументов: иначе следующая порция пришла бы в другом
  // порядке и товары бы поехали. Выключается ?isNewSortLogic=false.
  isNewSortLogic = true,
  // Сортировка, выбранная клиентом (?sort=). Клиентские дозагрузки её не
  // передают — берём ту, по которой отдана страница, чтобы порядок не поехал.
  /** @type {string | null} */ sort = null,
) => {
  return async (dispatch, getState) => {
    const { section, filter } = getState();
    const response = await Api.server.getCatalog(
      {
        params: { ...section.params },
        filter: { ...filter.params },
        host,
        resolvedUrl: resolvedUrl.split("?")[0],
        isNewSortLogic,
        sort: sort ?? section.catalogSort,
      },
      isReset,
    );

    if (response) {
      dispatch({ type: "FETCH_SECTION", payload: response.products });
      dispatch({ type: "SET_CATALOG_SORT", payload: response.sort ?? null });
      dispatch({ type: "SET_COUNT", payload: response.count });
      // Минимальная цена по всей выборке фильтра: старая мета подставляет её в
      // #MIN_PRICE#, новой она нужна из того же источника
      dispatch({ type: "SET_MIN_PRICE", payload: response.minPrice ?? 0 });
      dispatch({ type: "SET_STUB_DATA", payload: response.stubData });
      if (response.models.marks) {
        dispatch({ type: "FETCH_MARKS", payload: response.models.marks });
      }

      if (response.models.models) {
        dispatch({ type: "FETCH_MODELS", payload: response.models.models });
      }

      if (response.models.types) {
        dispatch({ type: "FETCH_TYPES", payload: response.models.types });
      }
      const { meta } = response;
      const currentPage = section.params?.pageNum || 1;

      if (meta) {
        if (currentPage > 1) {
          if (meta.title) {
            dispatch(setTitle(`${meta.title} - Страница ${currentPage}`));
          }
          if (meta.description) {
            dispatch(
              setDescription(`${meta.description} - Страница ${currentPage}`),
            );
          }
        } else {
          dispatch(setTitle(meta.title));
          dispatch(setDescription(meta.description));
        }
      }
      dispatch({ type: "SET_META", payload: meta });
      dispatch({ type: "SET_ID_NEED_FILTER", payload: true });
    } else {
      errorSent("errorHandled", "fetchSectionError", {
        resolvedUrl,
        host,
        filter: JSON.stringify(filter),
      });
    }
  };
};

export const setSectionId = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_SECTION_ID", payload: value });
  };
};

export const setPageNum = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_PAGE_NUM", payload: value });
  };
};

export const setPageSize = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_PAGE_SIZE", payload: value });
  };
};

export const setSortBy = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_SORT_BY", payload: value });
  };
};

export const setSortOrder = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_SORT_ORDER", payload: value });
  };
};
